import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="App min-h-screen bg-sugar-bg"><Navbar />
      <div className="mx-auto max-w-md px-6 py-24 text-center">
        <XCircle size={48} className="mx-auto text-sugar-muted" />
        <h1 data-testid="payment-cancel" className="mt-6 font-display text-2xl font-bold text-sugar-ink">Payment cancelled</h1>
        <p className="mt-2 text-sugar-ink2">No worries — your cart is still saved. You can complete checkout whenever you're ready.</p>
        <Button data-testid="cancel-retry-btn" onClick={() => navigate("/checkout")} className="mt-6 rounded-full bg-sugar-pink px-8 py-6 font-bold text-white hover:bg-sugar-pinkhover">Back to checkout</Button>
      </div>
    </div>
  );
}
